
import {
  defineComponent,
  computed,
} from 'vue';
import {
  useStore,
} from 'vuex';
import ClickWrapper from '@/components/ClickWrapper.vue';
import ResponsiveImage from '@/components/ResponsiveImage.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

library.add(faTimes);

export default defineComponent({
  components: {
    FontAwesomeIcon,
    ClickWrapper,
    ResponsiveImage,
  },

  setup() {
    const store = useStore();

    const componentProps = computed(() => store.getters['enlargement/props']);

    const close = () => {
      store.dispatch('enlargement/clear');
    };

    return {
      componentProps,
      close,
    };
  },
});
